var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPivotalTracker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#507EAB;}\r\n\t.st1{fill:#E67A1B;}\r\n\t.st2{fill:#DEDEDE;}\r\n\t.st3{fill:#466E95;}\r\n\t.st4{fill:#C86A18;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65,70c13.8,0,25-11.2,25-25c0-13.8-11.2-25-25-25S40,31.2,40,45C40,58.8,51.2,70,65,70L65,70z M65,25.1 c11,0,19.9,8.9,19.9,19.9c0,11-8.9,19.9-19.9,19.9C54,64.9,45.1,56,45.1,45C45.1,34,54,25.1,65,25.1L65,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.7,41.4l2.9-5.1l-4.9-8.5l-6.3,3.7l5.6,9.7C64.8,40.9,65.8,41,66.7,41.4L66.7,41.4z M63.3,48.6l-2.9,5.1 l4.9,8.5l6.4-3.7L66,48.9C65.2,49.1,64.2,49,63.3,48.6L63.3,48.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65,25.1C54,25.1,45.1,34,45.1,45c0,11,8.9,19.9,19.9,19.9v-3.2l-4.6-8l2.9-5.1c0.5,0.3,1.1,0.4,1.7,0.4v-8 c0,0,0,0,0,0c-0.3,0-0.7,0-1,0.1l-5.6-9.7l6.3-3.7l0.3,0.5V25.1L65,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M65,20c-13.8,0-25,11.2-25,25l0,0c0,13.8,11.2,25,25,25v-5.1C54,64.9,45.1,56,45.1,45c0-11,8.9-19.9,19.9-19.9 V20L65,20z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M64.7,27.8l-6.3,3.7l5.6,9.7c0.3-0.1,0.7-0.1,1-0.1c0,0,0,0,0,0V28.3L64.7,27.8L64.7,27.8z M63.3,48.6 l-2.9,5.1l4.6,8V49C64.4,49,63.8,48.9,63.3,48.6L63.3,48.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "63.3,48.6 63.3,48.6 63.3,48.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.7,41.7L62.7,41.7l-2.9-5.1H50V44h0V44h11.2C61.4,43,61.9,42.3,62.7,41.7L62.7,41.7z M67.3,48.3L67.3,48.3 l2.9,5.1H80V46H68.9C68.6,47,68.1,47.7,67.3,48.3L67.3,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M51.6,36.6H50V44h0V44h11.2c0.1-0.4,0.3-0.8,0.5-1.2L51.6,36.6L51.6,36.6z M68.5,46.9c-0.3,0.5-0.7,1-1.2,1.3 l0,0l2.9,5.1H79L68.5,46.9L68.5,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.2,47.8c-0.6-0.6-1.1-1.5-1.2-2.5l0,0h-5.9l-4.9,8.5l6.4,3.7L62.2,47.8L62.2,47.8z M69,44.7h5.9l4.9-8.5 l-6.4-3.7l-5.6,9.7C68.5,42.8,68.9,43.7,69,44.7L69,44.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M61,45.3h-5.9l-3.3,5.7l9.5-4.5C61.2,46.2,61.1,45.8,61,45.3L61,45.3L61,45.3z M73.4,32.5l-5.6,9.7 c0.3,0.3,0.6,0.7,0.8,1l9.8-4.6l1.4-2.5L73.4,32.5L73.4,32.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPivotalTracker);
export default __webpack_public_path__ + "static/media/Pivotal-Tracker.c4c56e2e980f686c8480370ae309cf8d.svg";
export { ForwardRef as ReactComponent };